<template>
	<form class="wide" @submit.prevent="submit">
		<div class="sections">
			<section class="section">
				<fieldset>
					<div>
						<div>
							<legend><span>Client Details</span></legend>
						</div>
						<div>
							<label><span>Internal Reference Number <span class="optional">— Optional </span></span>
								<div v-if="form.errors.get('client.internal_reference')" class="error-block">
									<p v-html="form.errors.get('client.internal_reference')"></p>
								</div>
								<div>
									<input v-model="form.data.client.internal_reference" type="text">
								</div>
							</label>
							<!--							<label><span>Title <span class="optional">— Optional </span></span>-->
							<!--								<div v-if="form.errors.get('client.title')" class="error-block">-->
							<!--									<p v-html="form.errors.get('client.title')"></p>-->
							<!--								</div>-->
							<!--								<select v-model="form.data.client.title">-->
							<!--									<option selected value="">—</option>-->
							<!--									<option value="Mr">Mr</option>-->
							<!--									<option value="Mrs">Mrs</option>-->
							<!--									<option value="Ms">Ms</option>-->
							<!--									<option value="Miss">Miss</option>-->
							<!--								</select>-->
							<!--							</label>-->
							<label><span>First name <span class="optional">— Optional </span></span>
								<div v-if="form.errors.get('client.name_first')" class="error-block">
									<p v-html="form.errors.get('client.name_first')"></p>
								</div>
								<input v-model="form.data.client.name_first" type="text">
							</label>
							<label><span>Last name <span class="optional">— Optional </span></span>
								<div v-if="form.errors.get('client.name_last')" class="error-block">
									<p v-html="form.errors.get('client.name_last')"></p>
								</div>
								<input v-model="form.data.client.name_last" type="text">
							</label>
							<label><span>Email </span>
								<div v-if="form.errors.get('client.email')" class="error-block">
									<p v-html="form.errors.get('client.email')"></p>
								</div>
								<input v-model="form.data.client.email" type="text">
							</label>
							<label><span>Phone <span class="optional">— Optional </span></span>
								<div v-if="form.errors.get('client.phone')" class="error-block">
									<p v-html="form.errors.get('client.phone')"></p>
								</div>
								<input v-model="form.data.client.phone" type="text">
							</label>
						</div>
					</div>
				</fieldset>
				<fieldset>
					<div>
						<div>
							<legend><span>Property Details</span></legend>
						</div>
						<div>
							<label><span>Address Name or Number <span class="optional">— Optional </span></span>
								<div v-if="form.errors.get('address.address_identifier')" class="error-block">
									<p v-html="form.errors.get('address.address_identifier')"></p>
								</div>
								<input v-model="form.data.address.address_identifier" type="text">
							</label>
							<label><span>Address Street <span class="optional">— Optional </span></span>
								<div v-if="form.errors.get('address.address_street')" class="error-block">
									<p v-html="form.errors.get('address.address_street')"></p>
								</div>
								<input v-model="form.data.address.address_street" type="text">
							</label>
							<label><span>Address Town/City <span class="optional">— Optional </span></span>
								<div v-if="form.errors.get('address.address_locality')" class="error-block">
									<p v-html="form.errors.get('address.address_locality')"></p>
								</div>
								<input v-model="form.data.address.address_locality" type="text">
							</label>
							<label><span>Address County <span class="optional">— Optional </span></span>
								<div v-if="form.errors.get('address.address_province')" class="error-block">
									<p v-html="form.errors.get('address.address_province')"></p>
								</div>
								<input v-model="form.data.address.address_province" type="text">
							</label>
							<label class="postcode"><span>Address Postcode </span>
								<div v-if="form.errors.get('address.address_postcode')" class="error-block">
									<p v-html="form.errors.get('address.address_postcode')"></p>
								</div>
								<input v-model="form.data.address.address_postcode" type="text">
							</label>
						</div>
					</div>
				</fieldset>
			</section>
			<section class="section">
				<div class="actions-aligned">
					<ul class="actions">
						<li>
							<process-button
								:processing="form.processing" class="button button--primary" text="Order Search Pack"/>
						</li>
					</ul>
				</div>
			</section>
		</div>
	</form>
</template>
<script>
import {createNamespacedHelpers} from "vuex";

const {mapActions} = createNamespacedHelpers("searchPacks");

export default {

	data() {
		return {
			formReady: true,
			form: this.newForm({
				client: {
					internal_reference: "",
					// title: "",
					name_first: "",
					name_last: "",
					email: "",
					dob: "",
					phone: "",
				},
				address: {
					address_identifier: "",
					address_locality: "",
					address_province: "",
					address_postcode: "",
				},
			}),
		};
	},

	props: {
		method: {
			type: String,
			default() {
				return "post";
			},
		},
	},

	methods: {
		...mapActions([
			"addModel",
		]),
		async submit() {
			if ("post" === this.method) {
				this.form.post("search-packs").then(response => {
					this.$vmodal.open({
						component: require("../../apps/portal/views/search-pack/modals/OrderDetails").default,
						props: {
							redirect: response.redirect,
							searchPack: response.searchPack,
						},
					});
				});
			}
		},
	},
};
</script>
